import { Star, Clock } from "lucide-react";

export const TrustStrip = () => {
  return (
    <div className="bg-wtr-warm py-3 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-wtr-gray">
          {/* 5 Star Rating */}
          <div className="flex items-center gap-2">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="font-semibold">White Glove Service</span>
          </div>

          {/* Years in Business */}
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-wtr-blue" />
            <span><strong>Local 20+ Years</strong> Experience</span>
          </div>

          {/* Response Time */}
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-wtr-blue" />
            <span><strong>Immediate</strong> Virtual Assessments</span>
          </div>
        </div>
      </div>
    </div>
  );
};